'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

var AssociationTerm = function (_React$Component) {
  _inherits(AssociationTerm, _React$Component);

  function AssociationTerm(props) {
    _classCallCheck(this, AssociationTerm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderTerm = _this.renderTerm.bind(_this);
    return _this;
  }

  AssociationTerm.prototype.renderTerm = function renderTerm(assoc) {
    if (assoc.negated === true) {
      var styles = {
        color: 'gray'
      };
      return React.createElement(
        'span',
        null,
        React.createElement(
          'span',
          { className: 'association-table__not-qualifier', title: 'NOT able to carry out the function of the associated GO term' },
          'NOT'
        ),
        React.createElement(
          'span',
          null,
          assoc.object.label
        )
      );
    } else {
      return assoc.object.label;
    }
  };

  AssociationTerm.prototype.render = function render() {
    var _props = this.props,
        assoc = _props.assoc,
        config = _props.config;

    var self = this;
    var query = this.props.termURL + assoc.object.id;
    var target = "_self";
    if (this.props.termInNewPage) {
      target = "_blank";
    }
    // console.log("object:" , assoc.object);
    return React.createElement(
      'div',
      { className: 'ontology-ribbon__content' },
      React.createElement(
        'a',
        {
          className: 'ribbon-link',
          href: query,
          rel: 'noopener noreferrer',
          target: target,
          title: assoc.object.label + " (" + assoc.object.id + ")"
        },
        self.renderTerm(assoc)
      )
    );
  };

  return AssociationTerm;
}(React.Component);

AssociationTerm.propTypes = process.env.NODE_ENV !== "production" ? {
  assoc: PropTypes.object.isRequired,
  config: PropTypes.object,
  row: PropTypes.number,
  termURL: PropTypes.string,
  termInNewPage: PropTypes.bool
} : {};

export default AssociationTerm;